import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'María Fernanda',
  location: 'Bogotá, Colombia',
  photo: 'https://randomuser.me/api/portraits/women/68.jpg',
  text: 'En menos de un mes recuperé la inversión 10 veces. Mis milhojas son ahora el producto estrella de mi catálogo. Las vecinas hacen fila los fines de semana.',
  rating: 5
}, {
  name: 'Valentina Ríos',
  location: 'Ciudad de México',
  photo: 'https://randomuser.me/api/portraits/women/44.jpg',
  text: 'Soy mamá de dos niñas y necesitaba un ingreso extra desde casa. Las recetas de galletas son a prueba de errores. Hoy vendo 80 galletas por semana.',
  rating: 5
}, {
  name: 'Sofía Hernández',
  location: 'Buenos Aires, Argentina',
  photo: 'https://randomuser.me/api/portraits/women/65.jpg',
  text: 'La guía de costos me cambió la vida. Antes cobraba lo que se me ocurría y siempre perdía. Ahora sé exactamente cuánto cobrar y cuánto gano.',
  rating: 5
}, {
  name: 'Daniela Castro',
  location: 'Lima, Perú',
  photo: 'https://randomuser.me/api/portraits/women/32.jpg',
  text: 'El hojaldre por fin me sale crujiente y dorado. Antes era un desastre. Lo mejor: las fotos para Instagram me trajeron 30 pedidos en una semana.',
  rating: 5
}, {
  name: 'Camila Torres',
  location: 'Santiago, Chile',
  photo: 'https://randomuser.me/api/portraits/women/76.jpg',
  text: 'Pensé que iba a ser otro PDF aburrido, pero es realmente un paso a paso. Hasta mi esposo se animó a hornear conmigo. Es nuestro proyecto familiar.',
  rating: 5
}, {
  name: 'Lucía Morales',
  location: 'Quito, Ecuador',
  photo: 'https://randomuser.me/api/portraits/women/52.jpg',
  text: 'Las galletas estilo New York se volvieron virales en mi ciudad. Tengo lista de espera de 2 semanas. Nunca creí que con un PDF podría cambiar tanto.',
  rating: 5
}];
export function Testimonials() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-cream relative" data-id="element-306">
      <div className="dashed-divider absolute top-0 left-0" data-id="element-307" />

      <div className="max-w-6xl mx-auto" data-id="element-308">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-309">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-caramel/10 text-caramel-dark font-medium text-sm mb-6 border border-caramel/20" data-id="element-310">
            <Star className="w-4 h-4 fill-caramel" data-id="element-311" />
            +1,200 alumnas felices
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-espresso leading-tight mb-4" data-id="element-312">
            Lo que dicen las repostera<span className="italic" data-id="element-313">s</span> que ya
            empezaron
          </h2>
          <p className="text-lg text-espresso-light max-w-2xl mx-auto" data-id="element-314">
            Historias reales de mujeres que transformaron su cocina en su primer
            negocio.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-315">
          {TESTIMONIALS.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: i % 3 * 0.1
        }} className="bg-white rounded-2xl p-6 shadow-soft border border-caramel/10 relative" data-id="element-316">
              <Quote className="absolute top-4 right-4 w-8 h-8 text-caramel/15" data-id="element-317" />

              {/* Stars */}
              <div className="flex gap-0.5 mb-3" data-id="element-318">
                {Array.from({
              length: t.rating
            }).map((_, idx) => <Star key={idx} className="w-4 h-4 fill-caramel text-caramel" data-id="element-319" />)}
              </div>

              <p className="text-espresso-light leading-relaxed mb-5 text-sm md:text-base" data-id="element-320">
                "{t.text}"
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-caramel/10" data-id="element-321">
                <img src={t.photo} alt={t.name} width={48} height={48} className="w-12 h-12 rounded-full object-cover border-2 border-caramel/20" loading="lazy" decoding="async" data-id="element-322" />
                <div data-id="element-323">
                  <div className="font-bold text-espresso text-sm" data-id="element-324">
                    {t.name}
                  </div>
                  <div className="text-xs text-espresso-light/80" data-id="element-325">
                    {t.location}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}